import { Icon, Text, Tooltip } from 'bold-ui'
import { ButtonLink } from 'components/route'
import { useRouteMatch } from 'react-router'

interface GrupoExameTableHeaderProps {
  quantidade: number
}

export function GrupoExameTableHeader(props: GrupoExameTableHeaderProps) {
  const match = useRouteMatch()

  const GRUPOS_EXAME_MAXIMO = 20

  const isOverQuantity = props.quantidade >= GRUPOS_EXAME_MAXIMO

  const buttonToolTipText = isOverQuantity
    ? `Não é possível adicionar mais de ${GRUPOS_EXAME_MAXIMO} grupos de exames`
    : ''
  return (
    <div style={{ textAlign: 'right' }}>
      <Tooltip text={buttonToolTipText} placement='auto'>
        <ButtonLink
          to={isOverQuantity ? match.url : `${match.url}/create`}
          kind='primary'
          size='small'
          disabled={isOverQuantity}
        >
          <Icon icon='plus' style={{ marginRight: '0.25rem' }} />
          <Text color='inherit'>Adicionar grupo de exames</Text>
        </ButtonLink>
      </Tooltip>
    </div>
  )
}
